<template>
  <div class="QueryContractItem QueryContractItemIV mt_5">
    <div class="QueryContractItem__head">
      <div class="mr_7">NO.{{ NO }}</div>
      <div class="QueryContractItem__head__date mr_7">
        建立日期：{{ contractData.createROCdate }}
      </div>
      <div class="QueryContractItem__head__insured mr_7">
        要保人：
        <!-- hover身分證、生日 -->
        <Tooltip
          v-if="familyid"
          position="top"
          :id="
            contractData.insurer_id.indexOf('~') > -1
              ? ''
              : contractData.insurer_id
          "
          :birthday="formatDate(contractData.insurer_birthday)"
        >
          <a
            v-on:click="
              routeToCustDetailWithCustomStatusCheck(contractData.insurer_id)
            "
            class="link text-underline"
          >
            {{ truncate(contractData.insurer_name, 8) }}
          </a>
        </Tooltip>
        <span v-else>{{ truncate(contractData.insurer_name, 8) }}</span>
      </div>
      <div class="d-flex justify-content-end">
        <Avatar
          class="mr-2"
          :gender="Number(contractData.insurer_gender)"
          :size="20"
          :height="20"
        />
        <strong>{{ contractData.insurer_age }}歲</strong>
      </div>
      <div class="d-flex float-right ml-auto justify-content-end">
        <button
          class="btn btn-default btn-md mr_2 text-nowrap"
          @click="featuresHandler('print')"
          style="width: 117px"
        >
          列印建議書
        </button>
        <button
          class="btn btn-default btn-md mr_2 text-nowrap"
          @click="featuresHandler('importMobile')"
          v-if="is_crm == '1' && !this.$store.getters.IsDirectMarketingUser"
          :disabled="!contractData"
          style="width: 117px"
        >
          匯入行動投保
        </button>
        <div class="dropdown float-right ml-auto">
          <button
            class="btn btn-default btn-md mr_0 text-nowrap"
            aria-expanded="false"
            aria-haspopup="true"
            data-toggle="dropdown"
          >
            更多···
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <a
              @click="featuresHandler('edit')"
              role="button"
              class="dropdown-item text-green text-underline"
              >修改建議書</a
            >
            <a
              v-if="
                is_crm == '1' &&
                !$store.getters.BuTest &&
                contractData.mc_prod_list[0].sc_prod_list.length > 0
              "
              @click="featuresHandler('importInsurance')"
              role="button"
              class="dropdown-item text-green text-underline"
              >匯入保單健檢</a
            >
            <a
              @click="
                confirmDelete();
                updateClickDate(
                  nowSelectProposal.prod_idx,
                  nowSelectProposal.prod_type,
                );
              "
              role="button"
              class="dropdown-item text-green text-underline"
              >刪除建議書</a
            >
          </div>
        </div>
      </div>
    </div>
    <component
      :is="Base"
      v-for="(MC, index) in contractData.mc_prod_list"
      :key="'mc_' + index"
      :contractData="contractData"
      :MC="MC"
      :index="index"
      :familyid="familyid"
      :route-to-cust-detail-with-custom-status-check="
        routeToCustDetailWithCustomStatusCheck
      "
    ></component>
    <div
      class="notice"
      v-show="
        insuredRiskWarnText(
          contractData.insurer_id,
          'ivCard',
          contractData.mc_prod_list[0],
        ) !== '' && contractData.prod_type !== '5'
      "
    >
      {{
        insuredRiskWarnText(
          contractData.insurer_id,
          "ivCard",
          contractData.mc_prod_list[0],
        )
      }}
    </div>
    <ChangePopup
      :crmMapList="crmMapList"
      :oldCrmMapList="oldCrmMapList"
      v-if="changePopupHandler"
      @cancel="changePopupHandler = false"
      @finish="toHandler"
    />
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import Avatar from "@/desktop/components/Avatar";
import moment from "moment";
// 投資型基本資料輸入
import Base_Type1 from "./QueryContractItem_IV/Base_Type1"; //1-1定期繳VL
import Base_Type2 from "./QueryContractItem_IV/Base_Type2"; //1-2定期+超額VUL
import Base_Type3 from "./QueryContractItem_IV/Base_Type3"; //1-3躉繳VL
import Base_Type4 from "./QueryContractItem_IV/Base_Type4"; //1-4躉繳VA
import Base_Type5 from "./QueryContractItem_IV/Base_Type5"; //1-5彈性繳VA
import Base_Type6 from "./QueryContractItem_IV/Base_Type6"; //1-6定期+超額VA
import Base_Type7 from "./QueryContractItem_IV/Base_Type7"; //1-7定期+彈性繳VL
import Base_Type8 from "./QueryContractItem_IV/Base_Type8"; //1-8定期+彈性繳VA
import ChangePopup from "@/desktop/views/mf/components/2.Query/2-3-1.QueryDetail/ChangePopup.vue";
import Tooltip from "@/desktop/components/ToolTip";

export default {
  mixins: [mf_Mixin],
  props: [
    "contractData",
    "selectedMode",
    "selected",
    "NO",
    "proposalIvScLength",
  ],
  components: {
    Avatar,
    Base_Type1,
    Base_Type2,
    Base_Type3,
    Base_Type4,
    Base_Type5,
    Base_Type6,
    Base_Type7,
    Base_Type8,
    ChangePopup,
    Tooltip,
  },
  data() {
    return {
      Base: "",
      proposal_IV_SC_length: 0, //投資型列表附約數量
      changePopupHandler: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    //是否含停售
    includeStopSale() {
      return this.contractData.mc_prod_list.some((mc) => {
        return (
          mc.stop_sale == "1" ||
          mc.sc_prod_list.some((sc) => {
            return sc.stop_sale == "1";
          })
        );
      });
    },
    //是否含無分分證
    includeNoId() {
      return (
        this.contractData.insured_id.indexOf("~") > -1 ||
        this.contractData.insurer_id.indexOf("~") > -1 ||
        this.contractData.mc_prod_list.some((mc) => {
          return mc.sc_prod_list.some((sc) => {
            return sc.insured_id.indexOf("~") > -1;
          });
        })
      );
    },
    is_crm() {
      return this.$store.getters.QueryDetailTarget.is_crm;
    },
    familyid() {
      return this.$store.getters.QueryDetailTarget.familyid;
    },
  },
  methods: {
    moment,
    init() {
      switch (this.contractData.prem_type) {
        case "1":
          this.Base = "Base_Type1";
          break;
        case "2":
          this.Base = "Base_Type2";
          break;
        case "3":
          this.Base = "Base_Type3";
          break;
        case "4":
          this.Base = "Base_Type4";
          this.hasAnnuity = true;
          break;
        case "5":
          this.Base = "Base_Type5";
          this.hasAnnuity = true;
          break;
        case "6":
          this.Base = "Base_Type6";
          this.hasAnnuity = true;
          break;
        case "7":
          this.Base = "Base_Type7";
          break;
        case "8":
          this.Base = "Base_Type8";
          this.hasAnnuity = true;
          break;
      }
    },
    getTotal_mc(mc) {
      let total = parseInt(mc.pol_premium);
      if (mc.sc_prod_list) {
        mc.sc_prod_list.forEach(
          (item) => (total += parseInt(item.pol_premium)),
        );
      }
      return total;
    },
    //刪除建議書
    async confirmDelete() {
      this.$emit("update:selected", this.contractData);
      await this.$nextTick();
      // 通知父層刪除該筆建議書
      this.$emit("delete-proposal", {
        prod_idx: this.contractData.prod_idx,
        prod_type: "1",
      });
    },
    // 通知父層該筆建議書動作
    async featuresHandler(mode) {
      this.$emit("update:selected", this.contractData);
      await this.$nextTick();

      this.$emit("select-contract-date-handler", this.contractData);
      this.$emit("features-handler", mode);
    },
    async routeToCustDetailWithCustomStatusCheck(custId) {
      this.$emit("update:selected", this.contractData);
      await this.$nextTick();

      this.$emit("select-contract-date-handler", this.contractData);
      if (this.$listeners["route-to-cust-detail"]) {
        this.$emit("route-to-cust-detail", custId);
        return;
      }
      this.routeToCustDetail(custId);
    },
  },
  watch: {
    NO: {
      handler() {
        this.contractData.NO = this.NO;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.QueryContractItem.QueryContractItemIV {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 2px #a0a0f0;
  .QueryContractItem__head {
    background-color: rgba(160, 160, 240, 0.2);
    border-bottom: solid 2px #a0a0f0;
    padding: 4px 15px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    &__date,
    &__insured {
      white-space: nowrap;
      flex-grow: 0;
    }
  }
}
.notice {
  color: #de4054;
  line-height: 40px;
  font-size: 13px;
  padding: 3px 7px;
  font-size: 16px;
}
.QueryContractItem.QueryContractItemIV .btn.btn-md {
  padding: 5px 5px;
  font-size: 17px;
}
.QueryContractItem.QueryContractItemIV .QueryContractItem__head {
  padding: 4px 7px;
}
.QueryContractItem.QueryContractItemIV .tooltip .tooltip-text,
.QueryContractItem.QueryContractItemIV .tooltip .tooltip-text strong {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
}
</style>
